export function navigateTo(href: string) {
  window.location.href = href;
}
